(ns pfo.automation.model)

(defn dispositions-upsert-info [disposition-atoms]
  (->>
    disposition-atoms
    (map deref)
    (filter #(or (:id %) (:name %)))
    (map (fn [disposition-info]
           (merge
             {:disposition_name (:name disposition-info)
              :disposition_new (:new disposition-info)
              :label_name (:label-name disposition-info)
              :label_new (:label-new disposition-info)}
             (when-not (:new disposition-info)
               {:disposition_id (:id disposition-info)})
             (when-not (:label-new disposition-info)
               {:label_id (:label-id disposition-info)}))))))
